import React from "react";
import { CustomerReviews } from "../../reviewModels";
import { RatingCounts } from "../ReviewsStarBreakdown";

interface ReviewsStarBreakdownContentProps {
  ratingCount: RatingCounts;
  filteredByRating: number | undefined;
  reviews: CustomerReviews;
}

const ReviewsStarBreakdownContent = ({
  ratingCount,
  filteredByRating,
  reviews,
}: ReviewsStarBreakdownContentProps) => {
  const getRatingReviewCount = (reviewCount: number) => {
    return (
      (reviewCount /
        reviews.productReviewDetails.filter(
          (review) => review.oneToFiveStarRating > 0,
        ).length) *
      100
    );
  };

  return (
    <>
      <p className="sr-only">{`${ratingCount.reviewCount} reviews rated this ${ratingCount.rating} out of 5 stars.`}</p>
      <ul aria-hidden="true" className="rating w-auto flex items-center pr-2">
        <li
          className={`text-sm leading-none text-black pr-1 ${
            ratingCount.rating === 1 && "w-2 text-center"
          }`}
        >
          {ratingCount.rating}
        </li>
        <li className="icon-star text-yellow-600" />
      </ul>
      <div aria-hidden="true" className="w-full flex items-center">
        <div
          className="progress-bar-border-fix h-2.5 mr-2 w-[calc(100%-40px)]"
          data-testid={`rating-progress-${ratingCount.rating}`}
          data-progress-percent={getRatingReviewCount(ratingCount.reviewCount)}
        >
          <span
            className={`block h-full relative overflow-hidden group-hover:bg-green-800 rounded-tl-xl rounded-bl-[14px] ${
              ratingCount.reviewCount > 0 ? "pl-1" : "pl-0"
            } ${
              getRatingReviewCount(ratingCount.reviewCount) === 100
                ? "rounded-tr-xl rounded-br-[14px]"
                : ""
            } ${
              filteredByRating && filteredByRating === ratingCount.rating
                ? "bg-green-800"
                : "bg-green-500"
            }`}
            style={{
              width: `${getRatingReviewCount(ratingCount.reviewCount)}%`,
            }}
          />
        </div>
        <span className="text-sm leading-none text-gray-800 grow">
          {ratingCount.reviewCount}
        </span>
      </div>
    </>
  );
};

export default ReviewsStarBreakdownContent;
